;(function(jQuery){
	"use strict"
	function FloFiltersPicker(element, selectElement)
	{

		var global = {
			element: false,
			selectElement: false,
			categoryText: '',
			allText: '',
			selectedCategories: [],
		}

		var pub = {}

		var fn = {

			encodeID: function(id)
			{
				return btoa(encodeURIComponent(id)).replaceAll('=','-');
			},

			init: function (element, selectElement)
			{
				global.element = element;
				global.selectElement = selectElement;

				global.categoryText = jQuery('[data-category-selection]').attr('data-category-selection');
				global.allText = jQuery('[data-all-selected]').attr('data-all-selected');

				pub.renderOptions = fn.renderOptions;

				fn.bindUiListeners();

				jQuery(document).ready(fn.initEventListeners);

				// jQuery(document).ready(fn.handleAccordionSelectAll);
			},

			initEventListeners: function ()
			{
				fn.find('.filter-picker__toggle').on('click', fn.toggleDropdownVisibility);

				// listen on parent dropdown for child accordion click, as accordion HTML loaded after event listeners
				fn.find('.filter-picker__dropdown-items').on('click', '.filter-picker__accordion', fn.toggleNestedDropdownVisibility);

				fn.find('.filter-picker__dropdown-items').on('change', '.filter-picker__item-label input', fn.handleDropdownItemsChange);

				fn.find('.filter-picker__dropdown-items').on('change', '.filter-picker__selectall input', fn.handleAccordionSelectAll);

				jQuery(document).click(function (event)
				{
					// close dropdowns when clicking outside
					if (!jQuery(event.target).closest('.filter-picker__multiselect').length)
					{
						jQuery('.filter-picker__multiselect').removeClass('filter-picker--open');
					}
				});
			},

			find: function(selector)
			{
				return jQuery(global.element).find(selector);
			},

			setOnChange: function(callback)
			{
				global.onChangeCallback = callback;
			},

			renderOptions: function (values, categories_selected)
			{
				var options = global.selectElement.find('option');
				var dropdown = global.element.find('.filter-picker__dropdown-items');
				var productTypeDropdown = jQuery(".js-cust-selector-product-type .filter-picker__toggle");

				var selectElementID = global.selectElement.attr('id');

				var selected = dropdown.find('input:checked').map(function(v,i){ return jQuery(i).attr('id'); }).toArray();
				var selected_vals = dropdown.find('input:checked').map(function(v,i){ return jQuery(i).val(); }).toArray();

				dropdown.html('');

				if (selectElementID === 'product-type')
				{
					if (values && values.length) // selected categories + product_types object
					{
						productTypeDropdown.prop('disabled', false);

						jQuery.each(values, function (index, category)
						{
							var categoryName = category.value;
							var currCatTypesSelected = selected.filter(function(type, x) {
								return type.includes(`item-${selectElementID}-` + fn.encodeID(categoryName));
							});

							var productTypes = category.product_types;

							var dropdownListItem = jQuery('<li class="filter-picker__label js-filter-category-li" role="presentation">')
								.appendTo(dropdown);

							var parentId = `all-${selectElementID}-` + fn.encodeID(categoryName);
							// nested dropdown accordion open by default
							if(selected.includes(parentId) || currCatTypesSelected.length > 0) {
								var accordionToggle = jQuery('<div class="filter-picker__accordion accordion-open" aria-expanded="true">').appendTo(dropdownListItem);
							} else {
								var accordionToggle = jQuery('<div class="filter-picker__accordion" aria-expanded="false">').appendTo(dropdownListItem);
							}

							var accordionCheckbox = jQuery('<div class="filter-picker__selectall">').appendTo(accordionToggle);
							if (currCatTypesSelected.length > 0 && currCatTypesSelected.length < productTypes.length) {
								var parentInsert = jQuery(`<input id="${parentId}" type="checkbox" class="partial" data-target-select="product-category" value="${categoryName}">`).prop('checked', true);
							} else {
								var parentInsert = jQuery(`<input id="${parentId}" type="checkbox" data-target-select="product-category" value="${categoryName}">`).prop('checked', selected.includes(parentId));
							}
							parentInsert.appendTo(accordionCheckbox);
							jQuery(`<label for="${parentId}" type="checkbox">${categoryName}</label>`).appendTo(accordionCheckbox);

							if(selected.includes(parentId) || currCatTypesSelected.length > 0) {
								var accordion = jQuery('<div class="filter-picker__nested-dropdown">').appendTo(dropdownListItem);
							} else {
								var accordion = jQuery('<div class="filter-picker__nested-dropdown" style="display: none;">').appendTo(dropdownListItem);
							}
							var accordionList = jQuery('<ul>').appendTo(accordion);
							var insert;
							jQuery.each(productTypes, function (innerIndex, product)
							{
								var accordionItem = jQuery('<li class="filter-picker__label filter-picker__item-label" role="presentation">').appendTo(accordionList);
								var childId = parentId.replace('all','item') + "-" + fn.encodeID(product.value);
								insert = jQuery(`<input id="${childId}" type="checkbox" value="${product.value}" data-product-text='${product.text}'>`)
									.appendTo(accordionItem)
									.prop('checked', selected.includes(childId));
								jQuery(`<label for="${childId}" type="checkbox"><span>${product.text}</span></label>`).appendTo(accordionItem);
							});
							fn.mapDropdownValuesToSelect(insert, true);
							fn.mapDropdownValuesToSelect(parentInsert, true);
						});
					}
					else
					{
						productTypeDropdown.prop('disabled', true);
					}
				}
				else if (selectElementID == 'function') {
					// TODO Update translations once we have them - also present in import script
					var traderFunctions = [
						'Comerciante',
						'Comerciante que é também um Fabricante/Processador',
						'Titular de Licença',
						'Importador',
						'Importeur',
						'Exportador',
						'Exporteur',
						'Handelsunternehmen, das auch Hersteller/Verarbeiter ist',
						'Lizenznehmer*innen',
						'Händler*innen',
						'Commerçant',
						'Détenteur de licence',
						'Commerçant qui est également fabricant/transformateur',
						'Importateur',
						'Importer',
						'Exportateur',
						'Exporter',
						'Licensee',
						'Trader that is also a Manufacturer/Processor',
						'Trader',
						'Comerciante',
						'Comerciante que también es Fabricante/Procesador',
						'Licenciatario',
						'Importador',
						'Exportador',
					];

					var producerFunctions = [
						'Produtor que também exporta para outros produtores',
						'Produtor',
						'Produtor que é também um Fabricante/Processador',
						'Produzent*innen',
						'Produzent*innenorganisation, die auch Hersteller/Verarbeiter ist',
						'Produzentinnenorganisation, die auch für andere Produzent*innenorganisationen exportiert',
						'Producteur qui est également fabricant/transformateur',
						'Producteur',
						"Producteur qui exporte également pour d'autres producteurs",
						'Producer that is also a Manufacturer/Processor',
						'Producer',
						'Producer that also exports for other producers',
						'Productor que también es Fabricante/Procesador',
						'Productor',
						'Productor que también exporta para otros productores',
					];

					var allFairtradersText = {
						'en': 'All Fairtrade traders',
						'es': 'Todos los comerciantes de Comercio Justo',
						'fr': 'Tous les acteurs commerciaux Fairtrade',
						'de': 'Alle Fairtrade-Händler*innen',
						'pt': 'Todos os comerciantes Fairtrade'
					};

					var allProducerText = {
						'en': 'All Fairtrade producer organisations',
						'es': 'Todas las organizaciones de productores Fairtrade',
						'fr': 'Toutes les organisations de producteurs Fairtrade',
						'de': 'Alle Fairtrade-Produzent*innenorganisationen',
						'pt': 'Todas as organizações de produtores Fairtrade'
					}

					var current_lang = jQuery('[name=flocert_language]').val();

					var functionsGroups = [
						{
							'text': allFairtradersText[current_lang] ? allFairtradersText[current_lang] : allFairtradersText['en'],
							'functions': options.filter((_, opt) => traderFunctions.includes(opt.text))
						},
						{
							'text': allProducerText[current_lang] ? allProducerText[current_lang] : allProducerText['en'],
							'functions': options.filter((_, opt) => producerFunctions.includes(opt.text))
						}
					];

					fn.updateFunctionsDefaultOptionLabel(functionsGroups);

					functionsGroups.forEach(function(group, index) {
						if (!group.functions.length)
						{
							return;
						}
						var dropdownListItem = jQuery('<li class="filter-picker__label" role="presentation">').appendTo(dropdown);
						var accordionToggle = jQuery('<div class="filter-picker__accordion accordion-open" aria-expanded="true">').appendTo(dropdownListItem);
						var accordionCheckbox = jQuery('<div class="filter-picker__selectall">').appendTo(accordionToggle);
						var parentId = `all-${selectElementID}-` + fn.encodeID(group.text);
						jQuery(`<input id="${parentId}" type="checkbox" data-target-select="product-category" value="${group.text}">`).appendTo(accordionCheckbox).prop('checked', selected.includes(parentId));
						jQuery(`<label for="${parentId}" type="checkbox">${group.text}</label>`).appendTo(accordionCheckbox);
						var accordion = jQuery('<div class="filter-picker__nested-dropdown">').appendTo(dropdownListItem);
						var accordionList = jQuery('<ul>').appendTo(accordion);
						var insert;
						group.functions.each(function (innerIndex, func)
						{
							var accordionItem = jQuery('<li class="filter-picker__label filter-picker__item-label" role="presentation">').appendTo(accordionList);
							var childId = parentId.replace('all', 'item') + '-' + fn.encodeID(func.value);
							insert = jQuery(`<input id="${childId}" type="checkbox" value="${func.value}">`).appendTo(accordionItem).prop('checked', selected.includes(childId));
							jQuery(`<label for="${childId}" type="checkbox"><span>${func.text}</span></label>`).appendTo(accordionItem);
						});
						fn.mapDropdownValuesToSelect(insert, true);
					});
				}
				else // all filters except product-type
				{
					var multiselectElem = jQuery(dropdown).closest('.filter-picker__multiselect');
					var max = multiselectElem.attr('max');

					options.each(function (index, option)
					{
						if (option.value) // exclude default option with empty value
						{
							var itemId = `item-${selectElementID}-` + fn.encodeID(option.value);
							var isDisabled = !selected.includes(itemId) && max && selected.length >= max;
							var listItem = jQuery('<li class="filter-picker__label filter-picker__item-label" role="presentation">')
								.attr('aria-disabled', isDisabled)
								.appendTo(dropdown);

							var selectedOptionInsert = jQuery(`<input id="${itemId}" type="checkbox" value="${option.value}">`);
							selectedOptionInsert
								.prop('checked', selected.includes(itemId))
								.attr('disabled', isDisabled)
								.appendTo(listItem);

							jQuery(`<label for="${itemId}" type="checkbox"><span>${option.value}</span></label>`).appendTo(listItem);
						}
						else
						{
							fn.handleLabelUpdate(multiselectElem, selected);
						}
					});

					global.selectElement.val(selected_vals);
				}
			},

			/**
			 * Update functions default option label to include a count based on the grouped options
			 * @param {Object} functionsGroups
			 */
			updateFunctionsDefaultOptionLabel: function(functionsGroups)
			{
				var functionSelect = jQuery('.js-cust-search-function-select');
				var defaultOption = functionSelect.children('[data-default-select-text]');
				var functionsFilters = fn.joinGroupFunctions(functionsGroups);
				CustomerSearch.addNumberOfValuesToDefaultOptionLabel(defaultOption, functionsFilters);
			},

			joinGroupFunctions: function(functionsGroups)
			{
				var functionsArrays = functionsGroups.map(group => group.functions.toArray());
				functionsArrays = functionsArrays.flat();

				return functionsArrays;
			},

			/**
			 * Throttle how reguarly a function can run
			 * @see https://remysharp.com/2010/07/21/throttling-function-calls
			 */
			throttle: function(fn, threshhold, scope) {
				threshhold || (threshhold = 250);
				var last,
					deferTimer;

				return function () {
					var context = scope || this;

					var now = +new Date,
						args = arguments;
					if (last && now < last + threshhold) {
						// hold on to it
						clearTimeout(deferTimer);
						deferTimer = setTimeout(function () {
							last = now;
							fn.apply(context, args);
						}, threshhold);
					} else {
						last = now;
						fn.apply(context, args);
					}
				};
			},

			bindUiListeners: function()
			{
				// may be required
			},

			toggleDropdownVisibility: function ()
			{
				var multiselects = jQuery('.filter-picker__multiselect');
				var targetMultiselect = global.element;
				var targetDropdown = targetMultiselect.find('.filter-picker__toggle');

				// close multiselects except target
				multiselects.not(jQuery(this).parent()).removeClass('filter-picker--open');

				// toggle target dropdown
				if (targetDropdown.attr('aria-expanded') === 'true')
				{
					targetDropdown.attr('aria-expanded', false);
					targetMultiselect.toggleClass('filter-picker--open');
				}
				else
				{
					targetDropdown.attr('aria-expanded', true);
					targetMultiselect.toggleClass('filter-picker--open');
				}

				jQuery('body').trigger('filters_picker_toggle_dropdown');
			},

			toggleNestedDropdownVisibility: function (event)
			{
				// prevent .filter-picker__accordion open/close when parent category checkbox is clicked
				if (jQuery(event.target).is(':checkbox') || jQuery(event.target).is('label'))
				{
					return;
				}

				var nestedDropdown = jQuery(this).siblings('.filter-picker__nested-dropdown');

				jQuery(this).attr('aria-expanded', function (i, attr)
				{
					return attr === 'true' ? 'false' : 'true';
				});

				jQuery(this).toggleClass('accordion-open');
				nestedDropdown.slideToggle(125); // speed 125ms
			},

			mapDropdownValuesToSelect: function (targetDropdownItem, skipTrigger)
			{
				var targetDropdownItem = targetDropdownItem;

				var targetMultiselect = global.element;
				var parentFilterGroup = targetDropdownItem.parents('.search-filter-group');
				var hiddenSelect = parentFilterGroup.find('.js-hidden-select');

				var selectedValues = fn.getSelectedInputValues	(targetMultiselect);

				var maxSelected = targetMultiselect.attr('max');

				if (maxSelected)
				{
					if(targetMultiselect.find('.filter-picker__nested-dropdown').length > 0 && targetMultiselect.find('.filter-picker__selectall input:checked').length >= maxSelected) {
						// nested maximums always refer to the top level
						fn.disableMultiselect(targetMultiselect, true);
					} else if (targetMultiselect.find('.filter-picker__nested-dropdown').length === 0 && targetMultiselect.find('input:checked').length >= maxSelected)
					{
						fn.disableMultiselect(targetMultiselect);
					}
					else
					{
						fn.enableMultiselect(targetMultiselect);
					}
				}

				if(!skipTrigger)
					hiddenSelect.val(selectedValues).trigger('change');

				if (targetMultiselect.hasClass('js-cust-selector-product-type'))
				{
					// We only want to pass through selected categories to handleLabelUpdate
					selectedValues = fn.getSelectedInputValues(targetMultiselect, true);
				}

				fn.handleLabelUpdate(targetMultiselect, selectedValues);
			},

			getSelectedInputValues: function(targetMultiselect, useSelectAllValues = false)
			{
				var selectedValues = [];
				var selector = useSelectAllValues ? '.filter-picker__selectall input:checked' : '.filter-picker__item-label input:checked';

				// set hidden select with checked checkbox value
				targetMultiselect.find(selector).each(function ()
				{
					selectedValues.push(jQuery(this).val());
				});

				return selectedValues;
			},

			/**
			 * Disable all the items of a multiselect that are not currently selected
			 * @param {jQuery} targetMultiselect
			 */
			disableMultiselect: function(targetMultiselect, nested = false)
			{
				if(nested) {
					targetMultiselect.find('.filter-picker__selectall input:not(:checked)').parents('.filter-picker__label').find('input:not(:checked)').each(function (i, selectInput) {
						// console.log('Disabling', selectInput);
						jQuery(selectInput).attr('disabled', true)
							.parent().attr('aria-disabled', true);
					});
				} else {
					targetMultiselect.find('input:not(:checked)').each(function (i, selectInput) {
						jQuery(selectInput).attr('disabled', true)
							.parent().attr('aria-disabled', true);
					});
				}
			},

			/**
			 * Remove the disabled/aria-disabled attributes from all items of a multiselect
			 * @param {jQuery} targetMultiselect
			 */
			enableMultiselect: function(targetMultiselect)
			{
				targetMultiselect.find('input:not(:checked)').each(function(i, selectInput) {
					jQuery(selectInput).removeAttr('disabled')
						.parent().removeAttr('aria-disabled');
				});
			},

			handleLabelUpdate: function(multiselectElem, selectedValues)
			{
				var targetDropdown = multiselectElem.find('.filter-picker__toggle');
				var parentFilterGroup = multiselectElem.parents('.search-filter-group');
				var hiddenSelect = parentFilterGroup.find('.js-hidden-select');
				var defaultSelectText = hiddenSelect.find('option[data-default-select-text]').attr('data-default-select-text');
				var dropdownSelectedLabel = targetDropdown.attr('data-label-selected');
				var dropdownSelectionText = (selectedValues.length > 0) ? selectedValues.length + ' ' + dropdownSelectedLabel : defaultSelectText;
				targetDropdown.text(dropdownSelectionText);
				targetDropdown.toggleClass('filter-picker__toggle--selections', (selectedValues.length > 0));
			},

			getSelectedFilterValues: function (targetDropdownItem)
			{
				var targetDropdownItem = targetDropdownItem;

				var targetMultiselect = global.element;
				var targetDropdownToggle = targetMultiselect.find('.filter-picker__toggle');

				var parentFilterGroup = targetDropdownItem.parents('.search-filter-group');
				var hiddenSelect = parentFilterGroup.find('.js-hidden-select');
				var selectId = hiddenSelect.attr('id');

				if (selectId === 'product-type')
				{
					var categorySelectID = 'product-category';
					var targetDropdownList = targetMultiselect.find('.filter-picker__dropdown-items');
					var selectedCategories = targetDropdownList.find('.filter-picker__selectall input[type=checkbox]:checked');

					selectedCategories.each(function ()
					{
						var categoryName = jQuery(this).val();
						var isSelected = jQuery(this).is(':checked');

						var valueText = `${global.categoryText} ${categoryName}: `;

						// check if category item already exists with valueText content
						var categoryId = jQuery(this).attr('id').replace('all-product-type-', '');
						var existingCategory = jQuery(`.results__item-product-category[data-category-id=${categoryId}]`);

						// if option is selected and category item doesn't exist, create a new item
						if (isSelected && existingCategory.length === 0)
						{
							var searchedItem = jQuery(`<p data-category-id="${categoryId}">`).appendTo(jQuery('.results__searchterms-categories'));
							searchedItem.addClass(`results__item-${categorySelectID}`);
							jQuery('<span class="results__item-name">').text(valueText).appendTo(searchedItem);
							jQuery(searchedItem).append('<span class="js-selected-products"></span>');
							global.selectedCategories.push(categoryId);
						}

						fn.populateSelectedProductsList(this, categoryId);
					});
				}
				else // Status, Certification, Function, Country selections
				{
					var targetDropdownList = targetMultiselect.find('.filter-picker__dropdown-items');
					var dropdownOptions = targetDropdownList.find('input[type=checkbox]');
					var selectedOptions = targetDropdownList.find('.filter-picker__item-label input[type=checkbox]:checked');
					var allOptionsSelected = (dropdownOptions.not(':checked').length > 0) ? false : true; // check if all checkboxes are checked

					var searchItemName = targetDropdownToggle.attr('data-default-select-text');
					var currentValue = targetDropdownItem.val();

					var selectedOptionValues = [];

					selectedOptions.each(function ()
					{
						currentValue = jQuery(this).siblings('label').text();
						selectedOptionValues.push(currentValue);
					});

					var valuesText = !allOptionsSelected ? selectedOptionValues.join(', ') : global.allText;

					if (selectedOptionValues && selectedOptionValues.length > 0)
					{
						var existingSearchItem = jQuery(`.results__item-${selectId}`);

						// Check if selection paragraph already exists: create new one if not, else clear its existing content
						if (existingSearchItem.length === 0)
						{
							var newSearchItem = jQuery('<p>').appendTo(jQuery('.results__searchterms-items'));
							newSearchItem.addClass(`results__item-${selectId}`);

							existingSearchItem = newSearchItem;
						}
						else
						{
							existingSearchItem.empty();
						}

						var itemName = jQuery('<span>').appendTo(existingSearchItem);
						itemName.addClass('results__item-name');
						itemName.text(`${searchItemName}: `);

						var valuesArrayList = jQuery('<span>').appendTo(existingSearchItem);
						valuesArrayList.addClass('results__item-list');

						if (selectId === 'function') {
							jQuery.post(brightmindedAjaxUrl, {
								'action': 'get_glossary_replaced_string',
								'str': valuesText,
							}).done(function(data)
							{
								valuesArrayList.append(JSON.parse(data).glossary_str);
							}).fail(function( data )
							{
								console.error('AJAX error with data : '+ data);
							});
						} else {
							valuesArrayList.append(valuesText);
						}
					}
					else
					{
						// If no selected options, remove the selection paragraph
						jQuery(`.results__item-${selectId}`).remove();
					}
				}
			},

			populateSelectedProductsList: function(dropdownItem, categoryId)
			{
				var parentLi = jQuery(dropdownItem).closest('.js-filter-category-li');
				var selectedProducts = parentLi.find('.filter-picker__nested-dropdown').find('input:checked');

				var selectedProductsTexts = [];

				selectedProducts.each(function(i, product) {
					var productText = jQuery(product).attr('data-product-text');
					selectedProductsTexts.push(productText);
				});

				jQuery(`.results__item-product-category[data-category-id=${categoryId}]`)
					.find('.js-selected-products').text(selectedProductsTexts.join(', '));
			},

			clearUnselectedCategories: function()
			{
				global.selectedCategories.forEach(function(categoryId) {
					var category = jQuery(`#all-product-type-${categoryId}`);
					if (!category.is(':checked')) {
						jQuery(`.results__item-product-category[data-category-id='${categoryId}']`).remove();
						var selectedCategoryIndex = global.selectedCategories.indexOf(categoryId);
						global.selectedCategories.splice(selectedCategoryIndex, 1);
					}
				});
			},

			handleDropdownItemsChange: function ()
			{
				var targetDropdownItem = jQuery(this);

				if(targetDropdownItem.parents('.filter-picker__nested-dropdown').length > 0) {
					var pid = targetDropdownItem.attr('id').replace(/^item/, 'all').replace(/-[a-zA-Z0-9]+-*$/, '');
					// targetDropdownItem.attr('id').replace(/^item/, 'all').match(/all\-[a-z]+\-[a-z]+-[a-zA-Z0-9]+/)[0]
					var parentTarget = jQuery('#' + pid);

					var parentTargetSelect = jQuery('.js-cust-search-' + parentTarget.data('target-select') + '-select');
					if(this.checked && !parentTargetSelect.val().includes(parentTarget.val())) {
						parentTarget.prop('checked', true);
						parentTargetSelect.val(parentTargetSelect.val().concat(parentTarget.val()));
					} else if (!this.checked && jQuery(this).parent().siblings().find('input:checked').length < 1) {
						parentTarget.prop('checked', false);
						parentTargetSelect.val(parentTargetSelect.val().filter(item => item !== parentTarget.val()));
					}
				}
				fn.mapDropdownValuesToSelect(targetDropdownItem);
				fn.getSelectedFilterValues(targetDropdownItem);
				fn.clearUnselectedCategories();
			},

			handleAccordionSelectAll: function ()
			{
				var targetSelect = jQuery('.js-cust-search-' + jQuery(this).data('target-select') + '-select');
				if (this.checked) {
					targetSelect.val(targetSelect.val().concat(jQuery(this).val()));
				} else {
					targetSelect.val(targetSelect.val().filter(item => item !== jQuery(this).val()));
				}

				var parentAccordion = jQuery(this).parents('.filter-picker__accordion');
				var nestedDropdown = parentAccordion.siblings('.filter-picker__nested-dropdown');

				// set nested 'child' checkboxes to same checked state as .filter-picker__selectall
				var childCheckboxes = nestedDropdown.find(':checkbox');
				if (childCheckboxes.length)
				{
					childCheckboxes.prop('checked', this.checked);
					jQuery(childCheckboxes[0]).trigger('change');
				}

				fn.clearUnselectedCategories();
			}
		}

		fn.init(element, selectElement);
		return pub;
	}

	window.FloFiltersPicker = FloFiltersPicker;

}(jQuery));
